import React from 'react';
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import WelcomingSectionImage from '@assets/welcoming-section-image.svg';
import WelcomingSectionImageCourierHeart from '@assets/welcoming-section-courierheart.svg';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { useTranslation } from 'react-i18next';
const WelcomingSectionContent = () => {
  const classes = useStyles();
  const { isResolutionMobile } = useDeviceDetect()
  const { t } = useTranslation()
  return (
    <div className={classes.welcomingContent}>
      <Typography variant={isResolutionMobile ? `h3` : `h1`} className={`welcoming-section-content-title ${isResolutionMobile ? `heading_l` : `heading_xxl`} `} align={isResolutionMobile ? `left` : `center`}>
        <JetFontIcon
          className="title-icon"
          iconname={JET_FONTICON_ALIASES.VEGAN}
          size={isResolutionMobile ? 25  : 33}
        />{' '}
        {t('new_productoverview_common.section2_title')}
      </Typography>
      <div className={'icons-holder'}>
        <img src={WelcomingSectionImage} />
        <img className={'heart-image'} src={WelcomingSectionImageCourierHeart} />
      </div>
      <Typography className="body_regular welcoming-description" variant="body1" align="center">
      {t('new_productoverview_common.section2_description')}
      </Typography>
    </div>
  );
};

export default WelcomingSectionContent;
